import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MasterSummaryQuestionModel, MasterSummaryPDModel, SurveyVersionQuestionModel, SurveyCutQuestionModel, AnswerTypes} from '../../../../models/survey/survey.model';
import {SurveyService} from '../../surveys.service';

import { PercentageType } from '../../../../shared/constants/percentage.constants';
import Utils from '../../../../shared/util/Util';
import { Observable } from 'rxjs';
import { CompareChartName } from '../../../../shared/constants/chart.constants';
import * as _ from 'lodash';
import { CommunicationService } from '../../../../shared/services/communication.service';

@Component({
  selector: 'app-compare-charting',
  templateUrl: './compare-charting.component.html',
  styleUrls: ['./compare-charting.component.less']
})
export class CompareChartingComponent implements OnInit {
  
  @Input() surveyId: number;

  question: MasterSummaryQuestionModel
  questionValue: MasterSummaryQuestionModel;

  @Input()
  get questionInput(): MasterSummaryQuestionModel {
    return this.questionValue;
  }

  set questionInput(val) {
    this.questionValue = val;
  }

  @ViewChild('screen') screen: ElementRef;
  @ViewChild('canvassource') canvas: ElementRef;
  @ViewChild('downloadLink') downloadLink: ElementRef;

  @Input() surveyMasterSummaryPDModel: MasterSummaryPDModel;
  @Input() chartJ: number;
  @Input() questionI: number;
  @Input() questionNumber: number;
  @Input() isSelectedAllResponses: boolean;
  surveyTitle: string;
  surveyVersionName: string;

  showDropdownChartType = false;
  defaultChart: string;

  label: string;
  shortLabel: string;

  listSurveyVersionValue: any;
  private listening = false;
  private globalClick: any;

  @Input()
  get listSurveyVersion() {
    return this.listSurveyVersionValue;
  }

  set listSurveyVersion(val) {
    if (Array.isArray(val)) {
      if (val.length >= 1) {
        this.listSurveyVersionValue = val;
      }
    } else {
      this.listSurveyVersionValue = [val];
    }
  }

  themeModeSelect = undefined;
  @Output() themeModeSelected = new EventEmitter<any[]>();
  @Output() compareChartModeSelected = new EventEmitter<any>();

  constructor(private surveyService: SurveyService, private cdRef:ChangeDetectorRef, private communicationService: CommunicationService) {
  }

  ngOnInit() {
    this.surveyService.getTitleSurvey(this.surveyId).subscribe(res => {
        this.surveyTitle = res;
        this.surveyVersionName = this.getDownloadFileName(this.surveyTitle);
    });
    this.question = Object.assign({}, this.questionInput);
    this.themeModeSelect = this.question.themeModeSelect;
    this.setDefaultChart();
    this.setVersionSegmentNames();
  }

  displayDropdownChartType(element) {
    if (!element.target.className || element.target.className.indexOf('radio-label-default-chart') < 0) {
      this.showDropdownChartType = !this.showDropdownChartType;
      if (this.showDropdownChartType) {
        this.globalClick = Observable
          .fromEvent(document, 'click')
          .delay(100)
          .do(() => {
            this.listening = true;
          }).subscribe((event: MouseEvent) => {
            this.onGlobalClick(element, event);
          });
      } else {
        this.listening = false;
        this.globalClick.unsubscribe();
      }
    }
  }

  onGlobalClick(element, event: MouseEvent) {
    if (event instanceof MouseEvent && this.listening === true) {
      if (!this.isDescendant(element.target, event.target)) {
        this.showDropdownChartType = false;
        this.listening = false;
        this.globalClick.unsubscribe();
      }
    }
  }

  isDescendant(parent, child) {
    let node = child;
    while (node !== null) {
      if (node === parent) {
        return true;
      } else {
        node = node.parentNode;
      }
    }
    return false;
  }

  changeModeChartDisplay(defaultChart: string) {
    this.defaultChart = defaultChart;
    this.surveyVersionName = this.getDownloadFileName(this.surveyTitle);
    this.setVersionSegmentNames();
    if (defaultChart === CompareChartName.DIFF) {
      let masterChart = this.obtainMasterChartObject();
      if (this.surveyMasterSummaryPDModel) {
        if (this.surveyMasterSummaryPDModel.listSurveyCutQuestion.length > 0) {
          this.calculateAllAbsolute(masterChart,this.surveyMasterSummaryPDModel.listSurveyCutQuestion,this.chartJ);
        }
        if (this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.length > 0) {
          this.calculateAllAbsolute(masterChart,this.surveyMasterSummaryPDModel.listSurveyVersionQuestion,this.chartJ);
        }
        if (this.surveyMasterSummaryPDModel.listQuestionModel.length > 0) {
          this.calculateAllAbsoluteAllResponses(masterChart,this.surveyMasterSummaryPDModel.listQuestionModel,this.chartJ);
        }
      }
    }
    this.compareChartModeSelected.emit(defaultChart)
  }

  allowShowParallelChart(): boolean {
    return ['SingleChoice', 'MultipleChoice'].includes(this.question.answerType);
  }

  allowShowBarChart(): boolean {
    let count = (this.isSelectedAllResponses ? 1 : 0)
      + this.surveyMasterSummaryPDModel.listSurveyCutQuestion.length
      + this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.length;
      return ['SingleChoice', 'MultipleChoice'].includes(this.question.answerType) && count === 2;
  }

  allowShowGaugeChart(): boolean {
    let count = (this.isSelectedAllResponses ? 1 : 0)
      + this.surveyMasterSummaryPDModel.listSurveyCutQuestion.length
      + this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.length;
    return ['OpinionScale', 'Number'].includes(this.question.answerType) && count >= 2 && count <= 8;
  }

  onThemeAction(_isOnTheme) {
    if (this.question.listAnswerModel && this.question.listAnswerModel.length > 0) {
      this.changeListAnswerModel(_isOnTheme);
    } else if (this.question.listAnswerModel && this.question.listAnswerModel.length === 0 && this.question.nizPitanja) {
      this.changeListNizPitanja(_isOnTheme)
    }
    this.themeModeSelected.emit(_isOnTheme);
  }

  get hasAnswerTheme() {
    const listAnswer = Object.assign([], this.question.copyListAnswerModel)
    for (const answer of listAnswer) {
      if(answer.answerTheme) return true
    }
    return false
  }

  allowShowStackedBarChart(): boolean {
    let count = (this.isSelectedAllResponses ? 1 : 0)
      + this.surveyMasterSummaryPDModel.listSurveyCutQuestion.length
      + this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.length;
    return ['OpinionScale'].includes(this.question.answerType) && count >= 2 && count <= 8;
  }
  
  get CompareChartName(): typeof CompareChartName {
    return CompareChartName
  }

  allowSortingCompareChart() {
    return this.defaultChart === CompareChartName.DIFF || this.defaultChart === CompareChartName.GAUGE;
  }

  onUpdatedSort(_sortType) {
    this.communicationService.sortCompareChartsChanged.next({
      sortType: _sortType
    }); 
  }

  private obtainMasterChartObject(): MasterSummaryQuestionModel {
    if (this.isSelectedAllResponses) {
      return this.surveyMasterSummaryPDModel.listQuestionModel[this.chartJ];
    } else {
      if (this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.length > 0) {
        return this.surveyMasterSummaryPDModel.listSurveyVersionQuestion[0].listQuestionModel[this.chartJ];
      } else if (this.surveyMasterSummaryPDModel.listSurveyCutQuestion.length > 0) {
        return this.surveyMasterSummaryPDModel.listSurveyCutQuestion[0].listQuestionModel[this.chartJ];
      }
    }
  }

  /*This function will iterate over all chart and it will call the function to calculate the absolute percentage difference
   *It will also reset the masterChart to not show the percentage difference in that chart
   */
   private calculateAllAbsolute(masterChart: MasterSummaryQuestionModel,listQuestion: SurveyVersionQuestionModel[] | SurveyCutQuestionModel[],questionIndex: number){
    let i: number;
    let auxChart: MasterSummaryQuestionModel;
    for(i=0;i<listQuestion.length;i++){
      auxChart = listQuestion[i].listQuestionModel[questionIndex];
      this.calculateAbsolute(masterChart,auxChart);
    }
  }

  private calculateAllAbsoluteAllResponses(masterChart: MasterSummaryQuestionModel,listQuestion: MasterSummaryQuestionModel[],questionIndex: number){
    this.calculateAbsolute(masterChart,listQuestion[questionIndex]);
  }

  //This function will apply this formula PercentageSibling - PercentageMaster to each question in the charts
  private calculateAbsolute(masterChart: MasterSummaryQuestionModel,siblingChart: MasterSummaryQuestionModel){
    if(masterChart && siblingChart && masterChart.listAnswerModel && siblingChart.listAnswerModel){
      let i: number;
      siblingChart.typePercentageSelected = PercentageType.ABSOLUTE;
      if(masterChart.listAnswerModel.length > 0 && siblingChart.listAnswerModel.length > 0){
        for(i=0 ; i<masterChart.listAnswerModel.length && i<siblingChart.listAnswerModel.length ; i++){
          siblingChart.listAnswerModel[i].answerDiffPercShow = true;
          let diffPercentage = siblingChart.listAnswerModel[i].answerPercentage - masterChart.listAnswerModel[i].answerPercentage;
          siblingChart.listAnswerModel[i].answerDiffPercentage = Utils.roundNumber(diffPercentage,1);
        }
      }else if(masterChart.nizPitanja && siblingChart.nizPitanja &&masterChart.nizPitanja.length > 0 && siblingChart.nizPitanja.length > 0){
        for(i=0 ; i<masterChart.nizPitanja.length && i<siblingChart.nizPitanja.length ; i++){
          siblingChart.nizPitanja[i].answerDiffPercShow = true;
          let diffPercentage = siblingChart.nizPitanja[i].answerPercentage - masterChart.nizPitanja[i].answerPercentage;
          siblingChart.nizPitanja[i].answerDiffPercentage = Utils.roundNumber(diffPercentage,1);
        }
      }
    }
  }

  private getDownloadFileName(name) {
    if (this.defaultChart === CompareChartName.PARALLEL) {
      return `Parallel ${name}`;
    } else if (this.defaultChart === CompareChartName.DIFF) {
      return `Percent Diff ${name}`;
    } else if (this.defaultChart === CompareChartName.GAUGE) {
      return `Gauge Ring ${name}`;
    } else if (this.defaultChart === CompareChartName.STACKED_BAR) {
      return `Stacked Bar ${name}`;
    }

    return '';
  }

  private setVersionSegmentNames() {
    let versionSegmentNames = [];
    if (this.isSelectedAllResponses) {
      versionSegmentNames.push('All responses');
    }
    if (this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.length > 0) {
      this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.forEach(s => {
        versionSegmentNames.push(s.surveyName);
      })
    }
    if (this.surveyMasterSummaryPDModel.listSurveyCutQuestion.length > 0) {
      this.surveyMasterSummaryPDModel.listSurveyCutQuestion.forEach(s => {
        versionSegmentNames.push(s.surveyName);
      })
    }
    if (versionSegmentNames.length > 1) {
      this.label = versionSegmentNames.join(' vs. ');
      if (this.label) {
        if (this.label.length > 100) {
          this.shortLabel = this.label.substring(0, 200) + '...';
        } else {
          this.shortLabel = this.label;
        }
      }
    }
  }

  private setDefaultChart() {
    if (_.isNil(this.question.compareChartModeSelect)) {
        if (['SingleChoice', 'MultipleChoice'].includes(this.question.answerType)) {
            this.defaultChart = CompareChartName.PARALLEL;
        }  else if (this.question.answerType === 'OpinionScale') {
          this.defaultChart = CompareChartName.STACKED_BAR;
        } else if (this.question.answerType === 'Number') {
          this.defaultChart = CompareChartName.GAUGE;
        }
    } else {
        this.defaultChart = this.question.compareChartModeSelect
    }
    this.changeModeChartDisplay(this.defaultChart);
  }

  private _onGroupAnswerByTheme(_isOnTheme, originalArrayChart, question){
    if (_isOnTheme && this.hasAnswerTheme){
      const listAnswerIndexed = this._groupAnswerByTheme(originalArrayChart)
      return this._generateListToEmit(listAnswerIndexed, originalArrayChart, question)
    } else if (!_isOnTheme && this.hasAnswerTheme){
      return Object.assign([], originalArrayChart)
    } else {
      return null
    }
  }

  private _groupAnswerByTheme(originalArrayChart) {
    const _listToReduce = Object.assign([], originalArrayChart)
    return _listToReduce.reduce((acc, el) => {
      let _answerName = el.answerTheme ? el.answerTheme : 'undefined'
      let _answerCount = el.answerCount
      let _answerPercentage = Number(el.answerPercentage)

      if (acc && acc[_answerName]) {
        _answerCount += 1
        _answerPercentage += Number(acc[_answerName].answerPercentage)
      }else {
        _answerCount = 1
      }

      acc[_answerName] = {
        ...el,
        answerName: _answerName,
        answerCount: _answerCount,
        answerPercentage: _answerPercentage
      }

      return acc
    }, [])
  }

  private assignMapThemes(originalArrayChart){
    const _mapThemes = new Map();
    for (const _answer of originalArrayChart) {
      if(_answer.answerTheme && _mapThemes.has(_answer.answerTheme)){
        const _value = _mapThemes.get(_answer.answerTheme)
        if(_answer.countAnswerTheme > _value){
          _mapThemes.set(_answer.answerTheme, _answer.countAnswerTheme)
        }
      }else if(_answer.answerTheme && !_mapThemes.has(_answer.answerTheme)){
        _mapThemes.set(_answer.answerTheme, _answer.countAnswerTheme)
      }

      if(!_answer.answerTheme && _mapThemes.has('undefined')){
        const _value = _mapThemes.get('undefined')
        if(_answer.countAnswerTheme > _value){
          _mapThemes.set('undefined', _answer.countAnswerTheme)
        }
      }else if(!_answer.answerTheme && !_mapThemes.has('undefined')){
        _mapThemes.set('undefined', _answer.countAnswerTheme)
      }
    }

    return _mapThemes
  }

  private _generateListToEmit(_listAnswerIndexed, originalArrayChart, question) {
    const _mapThemes = this.assignMapThemes(originalArrayChart)
    const _listToEmit = []

    for (const key in _listAnswerIndexed) {
        const el: any = _listAnswerIndexed[key];
        if (question.peopleReponsesCount === 0){
          el.answerCount = 0
          if(question.answerType === 'SingleChoice'){
            el.answerCount = _mapThemes.get(key)
          }
          el.answerPercentage = el.answerPercentage ? Number(el.answerPercentage).toFixed(2) : '0.00'
          _listToEmit.push(el)
        }else {
          el.answerCount = _mapThemes.get(key)
          el.answerPercentage = Number(((el.countAnswerTheme / question.peopleReponsesCount) * 100).toFixed(2))
          _listToEmit.push(el)
        }
    }
    
    return _listToEmit
  }

  private changeListAnswerModel(_isOnTheme){
    if(this.hasAnswerTheme && _isOnTheme){
        const listGrouped = this._onGroupAnswerByTheme(_isOnTheme, this.surveyMasterSummaryPDModel.listQuestionModel[this.chartJ].copyListAnswerModel, this.surveyMasterSummaryPDModel.listQuestionModel[this.chartJ])
        this.questionValue.listAnswerModel = listGrouped;
        this.question.listAnswerModel = this.questionValue.listAnswerModel;
        this.surveyMasterSummaryPDModel.listQuestionModel[this.chartJ].listAnswerModel = this.questionValue.listAnswerModel
        if (this.surveyMasterSummaryPDModel.listSurveyVersionQuestion && this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.length > 0) {
            this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.forEach(question => {
                if (question.listQuestionModel[this.chartJ]) {
                    const listGrouped = this._onGroupAnswerByTheme(_isOnTheme, question.listQuestionModel[this.chartJ].copyListAnswerModel, question.listQuestionModel[this.chartJ])
                    question.listQuestionModel[this.chartJ].listAnswerModel = listGrouped
                }
            }) 
        }
        if (this.surveyMasterSummaryPDModel.listSurveyCutQuestion && this.surveyMasterSummaryPDModel.listSurveyCutQuestion.length > 0) {
            this.surveyMasterSummaryPDModel.listSurveyCutQuestion.forEach(question => {
                if (question.listQuestionModel[this.chartJ]) {
                    const listGrouped = this._onGroupAnswerByTheme(_isOnTheme, question.listQuestionModel[this.chartJ].copyListAnswerModel, question.listQuestionModel[this.chartJ])
                    question.listQuestionModel[this.chartJ].listAnswerModel = listGrouped
                }
            }) 
        }
    } else {
        this.questionValue.listAnswerModel = this.questionValue.copyListAnswerModel;
        this.question.listAnswerModel = this.questionValue.listAnswerModel;
        this.surveyMasterSummaryPDModel.listQuestionModel[this.chartJ].listAnswerModel = this.questionValue.listAnswerModel
        if (this.surveyMasterSummaryPDModel.listSurveyVersionQuestion && this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.length > 0) {
            this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.forEach(question => {
                if (question.listQuestionModel[this.chartJ]) {
                    question.listQuestionModel[this.chartJ].listAnswerModel = question.listQuestionModel[this.chartJ].copyListAnswerModel
                }
            }) 
        }
        if (this.surveyMasterSummaryPDModel.listSurveyCutQuestion && this.surveyMasterSummaryPDModel.listSurveyCutQuestion.length > 0) {
            this.surveyMasterSummaryPDModel.listSurveyCutQuestion.forEach(question => {
                if (question.listQuestionModel[this.chartJ]) {
                    question.listQuestionModel[this.chartJ].listAnswerModel = question.listQuestionModel[this.chartJ].copyListAnswerModel
                }
            }) 
        }
    }
  }

  private changeListNizPitanja(_isOnTheme){
    if(this.hasAnswerTheme && _isOnTheme){
        const listGrouped = this._onGroupAnswerByTheme(_isOnTheme, this.surveyMasterSummaryPDModel.listQuestionModel[this.chartJ].copyNizPitanja, this.surveyMasterSummaryPDModel.listQuestionModel[this.chartJ])
        this.questionValue.nizPitanja = listGrouped;
        this.question.nizPitanja = this.questionValue.nizPitanja;
        this.surveyMasterSummaryPDModel.listQuestionModel[this.chartJ].nizPitanja = this.questionValue.nizPitanja
        if (this.surveyMasterSummaryPDModel.listSurveyVersionQuestion && this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.length > 0) {
            this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.forEach(question => {
                const listGrouped = this._onGroupAnswerByTheme(_isOnTheme, question.listQuestionModel[this.chartJ].copyNizPitanja, question.listQuestionModel[this.chartJ])
                question.listQuestionModel[this.chartJ].nizPitanja = listGrouped
            }) 
        }
        if (this.surveyMasterSummaryPDModel.listSurveyCutQuestion && this.surveyMasterSummaryPDModel.listSurveyCutQuestion.length > 0) {
            this.surveyMasterSummaryPDModel.listSurveyCutQuestion.forEach(question => {
                const listGrouped = this._onGroupAnswerByTheme(_isOnTheme, question.listQuestionModel[this.chartJ].copyNizPitanja, question.listQuestionModel[this.chartJ])
                question.listQuestionModel[this.chartJ].nizPitanja = listGrouped
            }) 
        }

    } else {
        this.questionValue.nizPitanja = this.questionValue.copyNizPitanja;
        this.question.nizPitanja = this.questionValue.nizPitanja;
        this.surveyMasterSummaryPDModel.listQuestionModel[this.chartJ].nizPitanja = this.questionValue.nizPitanja
        if (this.surveyMasterSummaryPDModel.listSurveyVersionQuestion && this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.length > 0) {
            this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.forEach(question => {
                question.listQuestionModel[this.chartJ].nizPitanja = question.listQuestionModel[this.chartJ].copyNizPitanja
            }) 
        }
        if (this.surveyMasterSummaryPDModel.listSurveyCutQuestion && this.surveyMasterSummaryPDModel.listSurveyCutQuestion.length > 0) {
            this.surveyMasterSummaryPDModel.listSurveyCutQuestion.forEach(question => {
                question.listQuestionModel[this.chartJ].nizPitanja = question.listQuestionModel[this.chartJ].copyNizPitanja
            }) 
        }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/master-summary/compare-charting/compare-charting.component.ts